export default {
  path: 'winter-service/v2/report',
  name: 'WinterService2Report',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ReportsIndex.vue')
}
